export default __webpack_public_path__ + "media/music/ee3623bd5b483baffe4d6bff394c85ea.mp3";